/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".OverlayExample-content{position:absolute;background:blue;color:white;position:absolute;bottom:0;left:0;right:0}\n"}]);